import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { RenderTextareaField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { uploadPhoto } from '../../../../actions/website/FileUploadActions';
import { addPhoto, updatePhoto } from '../../../../actions/website/entities/PhotosActions';

class PhotoForm extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.processError = this.processError.bind(this);

    const { photoUrl } = this.props;
    this.state = {
      showUpload: !photoUrl,
      error: undefined,
    };
  }

  onSubmit(values) {
    const { handleSubmit, hideModalFn } = this.props;
    handleSubmit(values)
      .then(() => hideModalFn())
      .catch(error => error.response.json().then(this.processError));
  }

  processError(error) {
    let errorMessage;

    if (error.category && error.category.domain === 'photo') {
      switch (error.category.reason) {
        case 'wedding-photo-limit-exceeded': {
          const photoLimit = error.message.match(/exceeded (.*) photo/);
          errorMessage = `There is a limit of ${
            photoLimit[1] || 100
          } photos. Please remove some photos and try again.`;
          break;
        }
        default:
          errorMessage = 'There was an error adding your photo. Please try again.';
      }
    } else {
      errorMessage = 'There was an error adding your photo. Please try again.';
    }

    this.setState({
      error: errorMessage,
    });
  }

  render() {
    const { submitting, valid, photoUrl, newPhoto, isUpdate } = this.props;
    const { error } = this.state;
    const img = newPhoto ? newPhoto.cloudfront_url : photoUrl;
    const photoStyle = { backgroundImage: `url(${img}?w=500&h=500)` };
    return (
      <div id="photo-form">
        <div className="modal-header">
          <h3 className="modal-title">{isUpdate ? 'Edit' : 'Add'} Photo</h3>
        </div>
        <div className="modal-body clearfix">
          <form onSubmit={this.onSubmit} id="photo-upload-form" noValidate>
            <div className="row">
              <div className="col-sm-6 col-xs-12">
                <div className="photo-preview" style={photoStyle} />
              </div>
              <div className="col-sm-6 col-xs-12 caption">
                <Field
                  name="caption"
                  id="photo-caption"
                  component={RenderTextareaField}
                  label="Description"
                  placeholder='We first said "I love you," right before our friend snapped this pic of us.'
                  maxChars={200}
                  validate={Validations.MAX_LENGTH_200}
                />
              </div>
            </div>
            {error && <p className="text-danger margin-top-2x">{error}</p>}
            <div className="save-button">
              <RenderSubmitButton submitting={submitting} valid={valid} pristine={false} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

PhotoForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  hideModalFn: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  photoUrl: PropTypes.string,
  newPhoto: PropTypes.shape({ uuid: PropTypes.string, cloudfront_url: PropTypes.string }),
  isUpdate: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  initialValues: Object.assign(
    {},
    { image_id: ownProps.newPhoto ? ownProps.newPhoto.uuid : undefined },
    state.website.entities.byId[state.website.entities.selectedEntityId]
  ),
  photoUrl: state.website.entities.selectedEntityId
    ? state.website.entities.byId[state.website.entities.selectedEntityId].image_url
    : undefined,
  filePreview: state.website.entities.filePreview.new_photo || {},
});

const mapDispatchToProps = dispatch => ({
  onSubmit: photoFormRequest =>
    photoFormRequest.id
      ? dispatch(updatePhoto(photoFormRequest))
      : dispatch(addPhoto(photoFormRequest)),
  onPhotoSelect: file => {
    dispatch(uploadPhoto(file, 'new_photo'));
  },
  onPhotoSelected: imageId => {
    dispatch(change('photoForm', 'image_id', imageId));
  },
});

const PhotoFormInstance = reduxForm({
  form: 'photoForm',
  enableReinitialize: true,
})(PhotoForm);

export default connect(mapStateToProps, mapDispatchToProps)(PhotoFormInstance);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/PhotoForm.jsx